import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import SearchInput from '../../SearchInput';
import Button from '../../UI/Button';
import { setSearchText } from '../Listing/actions';
import Wallet from './Wallet';
import AddMoney from '../Recharge/AddMoney';
import Helpline from '../../../components/Helpline';
import { sendEvent2 } from '../../../utils/tracking';

const SubHeader: FunctionComponent<{ searchText?: string }> = ({ searchText }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const searchVehicles = (searchStr: string) => {
    sendEvent2(
      'search_btn',
      {
        event_action: 'click',
        event_category: 'top_nav',
        screen_name: 'ft_homescreen',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    if (searchStr !== searchText) {
      dispatch(setSearchText(searchStr));
      history.push(`/portal/fastag${searchStr ? `?search=${searchStr}` : ''}`);
    }
  };

  return (
    <div className="main-nav-list">
      <div>
        <SearchInput
          onEnter={(searchText: string) => {
            searchVehicles(searchText);
          }}
          handleBlur={(searchText: string) => {
            searchVehicles(searchText);
          }}
          handleChange={() => {}}
          placeholder="Search Vehicle No. like ’5478’"
          value={searchText}
        />
      </div>
      <div>
        <Button
          variant="outlined"
          icon="download"
          clickHandler={() => {
            sendEvent2(
              'reports_btn',
              {
                event_action: 'click',
                event_category: 'top_nav',
                screen_name: 'ft_homescreen',
                target_product: 'fastag',
                event_platform: 'web',
              },
              true,
            );
            history.push('/portal/fastag/details');
          }}
        >
          Reports
        </Button>
      </div>
      <div style={{ position: 'relative' }}>
        <Wallet />
      </div>
      <div style={{ position: 'relative' }}>
        <AddMoney />
      </div>
      <div>
        <Button
          variant="outlined"
          icon="book"
          clickHandler={() => {
            sendEvent2(
              'passbook_btn',
              {
                event_action: 'click',
                event_category: 'top_nav',
                screen_name: 'ft_homescreen',
                target_product: 'fastag',
                event_platform: 'web',
              },
              true,
            );
            history.push('/portal/fastag/passbook');
          }}
        >
          Passbook
        </Button>
      </div>
      <div>
        <Helpline />
      </div>
    </div>
  );
};

export default SubHeader;
